export default __webpack_public_path__ + "static/media/user.5b2d2c83.jpg";